module.exports = __webpack_public_path__ + "img/thumbnail_Cheetah_j_albino.6e1acf76.png";